import React, { useEffect, useState } from "react";
import { NewTab, PageTab, PageTabAdv } from "../../../components";
import Overview from "./EmployeeProfile/Overview";
import GeneralEducation from "./EmployeeProfile/GeneralEducation";
import WorkAuthorization from "./EmployeeProfile/WorkAuthorization";
import Immigration from "./EmployeeProfile/Immigration";
import { useLocation } from "react-router-dom";
import Placements from "./EmployeeProfile/Placements";
import Documents from "./EmployeeProfile/Documents";
// import EmploymentHistory from "./EmployeeProfile/EmploymentHistory";
import Confidential from "./EmployeeProfile/Confidential";
import Timesheets from "./EmployeeProfile/Timesheets";
import Payments from "./EmployeeProfile/Payments";
import Invoices from "./EmployeeProfile/Invoices";
import OnboardingDocuments from "./EmployeeProfile/OnboardingDocuments";
import { useSelector } from "react-redux";

const Employee = () => {
  const location = useLocation();
  const employmentType =
    useSelector(
      (state) => state.employee.currentEmployee.employeeDetails.employmentType
    ) || 0;
  const { code } = location.state || {}; // Access the code passed via state
  const openAddUserModal = () => {
    alert("open Add User Modal");
  };
  const EmployeeMenus = [
    {
      title: "Overview",
      page: <Overview />,
      type: "main",
      icon: "grid_view",
    },

    {
      title: "General & Education",
      page: <GeneralEducation />,
      type: "main",
      icon: "person",
    },
    {
      title: "Work Authorization",
      page: <WorkAuthorization />,
      type: "main",
      icon: "family_history",
    },
    // {
    //   title: "Immigration",
    //   page: <Immigration />,
    //   type: "main",
    //   icon: "connecting_airports",
    // },
    {
      title: "Placements",
      page: <Placements />,
      type: "main",
      icon: "business_center",
    },
    ////////////////////
    {
      title: "Documents",
      page: <Documents />,
      type: "main",
      icon: "folder_check",
    },
    // {
    //   title: "Employment History",
    //   page: <EmploymentHistory />,
    //   type: "main",
    //   icon: "business_center",
    // },
    {
      title: "Confidential",
      page: <Confidential />,
      type: "main",
      icon: "visibility_lock",
    },
    {
      title: "Timesheets",
      page: <Timesheets />,
      type: "main",
      icon: "punch_clock",
    },
    {
      title: "Payments",
      page: <Payments />,
      type: "main",
      icon: "payments",
    },
    {
      title: "Invoices",
      page: <Invoices />,
      type: "main",
      icon: "receipt_long",
    },
    {
      title: "Onboarding Documents",
      page: <OnboardingDocuments />,
      type: "main",
      icon: "business_center",
    },
  ];
  const RefMenus = [
    {
      title: "Overview",
      page: <Overview />,
      type: "main",
      icon: "grid_view",
    },

    {
      title: "General & Education",
      page: <GeneralEducation />,
      type: "main",
      icon: "person",
    },
    // {
    //   title: "Work Authorization",
    //   page: <WorkAuthorization />,
    //   type: "main",
    //   icon: "family_history",
    // },
    // {
    //   title: "Immigration",
    //   page: <Immigration />,
    //   type: "main",
    //   icon: "connecting_airports",
    // },
    // {
    //   title: "Placements",
    //   page: <Placements />,
    //   type: "main",
    //   icon: "business_center",
    // },
    ////////////////////
    {
      title: "Documents",
      page: <Documents />,
      type: "main",
      icon: "folder_check",
    },
    {
      title: "Payments",
      page: <Payments />,
      type: "main",
      icon: "payments",
    },
    // {
    //   title: "Employment History",
    //   page: <EmploymentHistory />,
    //   type: "main",
    //   icon: "business_center",
    // },
    // {
    //   title: "Confidential",
    //   page: <Confidential />,
    //   type: "main",
    //   icon: "visibility_lock",
    // },
    // {
    //   title: "Timesheets",
    //   page: <Timesheets />,
    //   type: "main",
    //   icon: "punch_clock",
    // },
    // {
    //   title: "Payments",
    //   page: <Payments />,
    //   type: "main",
    //   icon: "payments",
    // },
    // {
    //   title: "Invoices",
    //   page: <Invoices />,
    //   type: "main",
    //   icon: "receipt_long",
    // },
    // {
    //   title: "Onboarding Documents",
    //   page: <OnboardingDocuments />,
    //   type: "main",
    //   icon: "business_center",
    // },
  ];

  return (
    <div className="flex flex-1 overflow-hidden">
      <NewTab
        tabs={employmentType === 4 ? RefMenus : EmployeeMenus}
        //mainTabsShow={10}
        color="black"
        variant="outlined"
        mode="url"
        tabId="profile-info"
      />
    </div>
  );
};

export default Employee;
